export default __webpack_public_path__ + "static/media/backgroundCommon.72f8caa6.mp3";